import cities from './cities'
const initialState = () => {
    return {
        machineId: '',
        branchOffice: 1,
        communeID: 26,
        communes: [],
        cities: cities,
        preventPrint: localStorage.getItem('_prevent_print'),
        isTransbankIntegrated:
            localStorage.getItem('transbank-integrated') || false,
        companyData: JSON.parse(localStorage.getItem('company-data')) || null,
        htmlPrint: JSON.parse(localStorage.getItem('html-print')) || false,
        customerCreditOptions: [],
        pchPaymentConditions: [],
    }
}

export default initialState
